import React, { useContext, useEffect, useState } from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, Row, Col,
    FormGroup, Label, Input, Button
} from 'reactstrap';
import Select from 'react-select';
import { AuthContext } from '../../context/AuthContext';

import { FormaPagamentoContext } from '../../context/FormaPagamentoContext';
import { CreateFormaPagamentoType } from '../../context/hooks/useFormaPagamento';

import { CurrencyInput } from '../Form/CurrencyInput';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    onCreated?: () => void;
}

export const CreateFormaPagamentoModal: React.FC<Props> = ({ isOpen, toggle, onCreated }) => {
    const { objUserTk } = useContext(AuthContext);
    const { createFormaPagamento } = useContext(FormaPagamentoContext);

    const [form, setForm] = useState<CreateFormaPagamentoType>({
        name: '',
        linkGateway: '',
        token: '',
        empresaId: objUserTk.EmpresaId,
    });

    useEffect(() => {
        if (isOpen) {
            setForm({
                name: '',
                linkGateway: '',
                token: '',
                empresaId: objUserTk.EmpresaId,
            });
        }
    }, [isOpen]);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const ok = await createFormaPagamento({
            ...form,
        });
        if (ok) {
            onCreated?.();
            toggle();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Adicionar forma de pagamento</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label className="form-control-label">Forma de Pagamento</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={onChange}
                                    placeholder="Forma de pagamento"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Link do Gateway</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="linkGateway"
                                    value={form.linkGateway}
                                    onChange={onChange}
                                    placeholder="Link do gateway de pagamento"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Token</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="token"
                                    value={form.token}
                                    onChange={onChange}
                                    placeholder="Token de autenticação"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-end mt-3">
                        <Button style={{ background: '#585858', color: '#fff' }} type="submit">Criar forma de pagamento</Button>
                        <Button style={{ background: '#585858', color: '#fff' }} className="ml-2" onClick={toggle}>Cancelar</Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};
export default CreateFormaPagamentoModal;